// extracted by mini-css-extract-plugin
module.exports = {"card":"feature-card_card__oQmiR","iconContainer":"feature-card_iconContainer__55o6r","title":"feature-card_title__pgpya","body":"feature-card_body__mPXPl"};